export default __webpack_public_path__ + "static/media/logopress_nftnyc.13cc6dac.svg";